/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./referral.vue?vue&type=template&id=2cfe1748&scoped=true"
import script from "./referral.vue?vue&type=script&lang=js"
export * from "./referral.vue?vue&type=script&lang=js"
import style0 from "./referral.vue?vue&type=style&index=0&id=2cfe1748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfe1748",
  null
  
)

export default component.exports